
const API_ENDPOINTS = {
  AUTH: {
    SIGNUP: '/business-registration',
    LOGIN: '/cpa-login',
    LOGOUT: '/cpa-logout',
  },
  PANEL: {
    STATS: `/dashboard`,
    CUSTOMER: {
      LISTING: `/list-customer`,
      CREATE: `/create-customer`,
      SHOW: `/view-customer/:id`,
      UPDATE: `/customer/:id`,
      DELETE: `/customer/:id`,
      MAIL: `/customer/:id/mail`,
      MAIL_LISTING: `/customer/mail`,
      MAIL_DETAILS: `/customer/mail-detail/:id`,

      DOCUMENT: {
        LISTING: `/customer/:customerId/document`,
        CREATE: `/customer/:customerId/document`,
        SHOW: `/customer/:customerId/document/:id`,
        UPDATE: `/customer/:customerId/document/:id`,
        DELETE: `/customer/:customerId/document/:id`,
       
        PREVIEW: `/customer/:customerId/document/:id/preview`,
        DOWNLOAD: `/customer/:customerId/document/:id/download`,
        VERIFY: `/customer/:customerId/document/:id/verify`,
        UNVERIFY: `/customer/:customerId/document/:id/unverify`,

      },

      MESSAGE : {
        GET_CONVERSATION_ID : `/customer/find-or-create-conversation/:id`,
        GET_CUSTOMER_INFO : `/customer/get-customer-detail/:id`,
        CONVERSATION_LISTING : `/customer/conversation-list`,
        SEND : '/customer/message-send',
        LISTING : `/customer/conversation/:id`
      }
    }
  }
};

// Helper function to build endpoints with params
export const buildEndpoint = (endpoint, params = {}) => {
  if (!endpoint || typeof endpoint !== 'string') return '';

  return endpoint.replace(/:([a-zA-Z]+)/g, (_, key) => {
    return params[key] !== undefined ? params[key] : `:${key}`;
  });
};

export default API_ENDPOINTS;
